export default "__VITE_ASSET__OawbKmLr__"